<template>
  <div class="tabs-wrapper" :class="{ 'tabs-wrapper--inline': inline }">
    <el-scrollbar class="tabs-scroll">
      <Tabs
        :model-value="String(activeTab)"
        @update:model-value="$emit('change:tab', $event)"
      >
        <TabsList>
          <TabsTrigger
            v-for="(tab, key) in tabs"
            :key="key"
            :value="String(key)"
            :disabled="!!tab.disabled"
            :title="tab.disabled && tab.tooltip ? tab.tooltip : undefined"
          >
            <svg-icon
              v-if="tab.icon"
              :name="tab.icon"
              class="w-4 h-4 shrink-0"
              :class="String(activeTab) === String(key) ? 'text-blue-500' : ''"
            />
            <span
              :class="String(activeTab) === String(key) ? 'text-blue-500' : ''"
            >
              {{ tab.label }}
            </span>
            <span
              v-if="tab.count !== undefined && tab.count !== null"
              class="inline-flex h-[18px] min-w-[18px] shrink-0 items-center justify-center rounded-full px-1.5 text-[10.5px] font-medium leading-none"
              :class="
                String(activeTab) === String(key)
                  ? 'bg-muted text-foreground'
                  : 'bg-background/60 text-muted-foreground'
              "
            >
              {{ formatCount(tab.count) }}
            </span>
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </el-scrollbar>

    <div class="action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
import { Tabs, TabsList, TabsTrigger } from "@/shared/ui/tabs";

export default {
  name: "BaseTabs",
  components: { Tabs, TabsList, TabsTrigger },
  props: {
    tabs: { type: Object, required: true },
    activeTab: { required: true },
    inline: { type: Boolean, default: false },
  },
  emits: ["change:tab"],
  methods: {
    formatCount(value) {
      const n = Number(value);
      if (!Number.isFinite(n)) return value;
      return n > 9 ? "9+" : String(n);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-wrapper {
  @apply flex w-full items-center justify-between gap-3;

  &--inline {
    @apply inline-flex w-fit shrink-0 justify-start;
  }
}

.tabs-scroll {
  min-width: 0;
  flex: 1;
}

.tabs-wrapper--inline .tabs-scroll {
  flex: 0 0 auto;
}

.tabs-scroll :deep(.el-scrollbar__bar.is-horizontal) {
  display: none;
}

.action {
  @apply flex-shrink-0;
}
</style>
